import { Flex } from "@chakra-ui/layout";
import { Box, Image, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Onboardingmodal from "../components/onboardingModal";
import { BiAdjust } from "react-icons/bi";
import Branding from "../assets/images/wintergardenz-logo.webp";

export default function Onboarding() {
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  const authData = useSelector((state) => state?.auth);

  const [isModalOpen, setIsModalOpen] = useState(true);
  // useState(!is_setup_complete);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate("/dashboard");
  };

  // useEffect(() => {
  //   if (is_setup_complete) {
  //     setIsModalOpen(true);
  //   } else {
  //     setIsModalOpen(true);
  //   }
  // }, [is_setup_complete]),
  //   console.log("Onboarding", is_setup_complete, isModalOpen);

  const styles = {
    background: {
      flexDirection: "column",
      alignItems: "center",
      height: "100vh",
      bgGradient: "linear(to-br, #7928CA, #0762ef)",
    },
    topContainer: {
      flexDirection: "column",
      p: { base: 2, md: 10 },
      marginTop: "10vh",
      borderRadius: 10,
      justifyContent: "center",
      alignItems: "center",
    },
  };
  return (
    <Flex {...styles.background}>
      <Box
        width={"100%"}
        height="7.5vh"
        bgColor={"white"}
        alignContent={"center"}
        px={10}
        marginTop={0}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <div
            style={{
              mx: "2%",
            }}
          >
            <Text color={"black"} fontWeight={"400"} fontSize={"20"}>
              Elex Partners
            </Text>
          </div>
          <div
            style={{
              mx: "2%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <BiAdjust size={"16"} color="black" />
            <Text color={"black"} fontWeight={"400"} fontSize={"20"}>
              Elex Partners
            </Text> */}
          </div>
        </Box>
      </Box>
      <Flex>
        <Onboardingmodal isOpen={isModalOpen} onclose={handleCloseModal} />
      </Flex>
    </Flex>
  );
}
